import {Component, HostListener, OnInit} from '@angular/core';
import { MeasurementType } from '../../model/measurement-type';
import { Tenant } from '../../model/tenant';
import { BasicFilters } from '../../model/filters/basic-filters';
import { MeasurementTypesService } from '../../services/measurement-types.service';
import { TenantsService } from '../../services/tenants.service';
import { TranslocoService } from '@ngneat/transloco';
import { AuthGuard } from '../../common/auth-guard.service';
import { CommonMessagesService } from '../../services/common-messages.service';
import { SortOrder } from '../../model/sort-order';
import { MeasurementTypeFilters } from '../../model/filters/measurement-type-filters';
import {FiltersService} from "../../services/filters.service";
import {SelectItem} from "primeng/api";
import {DataType} from "../../model/data-type";

@Component({
  selector: 'app-measurement-types',
  templateUrl: './measurement-types.component.html',
  styleUrls: ['./measurement-types.component.scss']
})
export class MeasurementTypesComponent implements OnInit {

  public types: MeasurementType[];
  public totalTypes: number;
  public loadingTypes: boolean;
  public tenants: Tenant[];

  public rows = 10;
  public first = 0;
  public selected = [];
  public dataTypes: SelectItem[];

  public filtersVisible: boolean;
  public currentFilters: MeasurementTypeFilters;
  public displayFailedDeleteList: boolean;
  public failedDeleteList: any[];
  public filtersFilled: boolean;

  constructor(private measurementTypesService: MeasurementTypesService,
              private tenantsService: TenantsService,
              private i18n: TranslocoService,
              public authGuardService: AuthGuard,
              private commonMessagesService: CommonMessagesService,
              private filtersService: FiltersService<MeasurementTypeFilters>) {
    this.dataTypes = [
      {label: 'forms.sensorType.STRING', value: DataType.STRING},
      {label: 'forms.sensorType.NUMBER', value: DataType.NUMBER},
      {label: 'forms.sensorType.BOOLEAN', value: DataType.BOOLEAN},
      {label: 'forms.sensorType.COORDINATES', value: DataType.COORDINATES},
      {label: 'forms.sensorType.ANALOG_SIGNAL', value: DataType.ANALOG_SIGNAL},
      {label: 'forms.sensorType.DIGITAL_SIGNAL', value: DataType.DIGITAL_SIGNAL}
    ];
    this.currentFilters = new MeasurementTypeFilters();
  }

  ngOnInit(): void {
    if (this.filtersService.getCurrentFilters(this.constructor.name) !== undefined) {
      this.filtersFilled = true;
    }
    this.types = new Array(this.rows);
    if (this.authGuardService.superAdminRequired()) {
      this.tenantsService.getTenants().subscribe(response => {
        this.tenants = response.tenants
          .sort((a, b) => a.name > b.name ? 1 : -1);
        Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
      });
    }  else {
      Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
    }
  }

  private loadTypes(offset: number, limit: number): void {
    this.loadingTypes = true;
    this.types = new Array(this.rows);
    this.selected = [];
    this.measurementTypesService.getMeasurementTypes(offset, limit, this.filtersService.getCurrentFilters(this.constructor.name) === undefined ? this.currentFilters: this.filtersService.getCurrentFilters(this.constructor.name))
      .subscribe(response => {
        this.types = response.measurementTypes;
        this.totalTypes = response.totalElements;
        this.loadingTypes = false;
      });
  }

  onPageChange(event): void {
    this.currentFilters.sortField = event.sortField;
    this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.loadTypes(event.first / event.rows, event.rows);
  }

  resetFilters(): void {
    this.currentFilters = new MeasurementTypeFilters();
    this.currentFilters.sortField = 'sensor';
    this.currentFilters.sortOrder = SortOrder.ASCENDING;
    this.filtersFilled = false;
    this.filtersService.setCurrentFilters(undefined, this.constructor.name);
    this.applyFilters(true);
  }

  applyFilters(reset?: boolean): void {
    this.first = 0;
    if (reset !== true){
      this.filtersService.setCurrentFilters(this.currentFilters, this.constructor.name);
      this.filtersFilled = true;
    }
    this.loadTypes(this.first / this.rows, this.rows);
  }

  confirmAndDelete(type: MeasurementType): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => {
      this.deleteType(type.tenant.uuid, type.sensor);
    });
  }

  deleteType(tenantUuid: string, sensor: string): void {
    this.tenantsService.deleteTenantMeasurementType(tenantUuid, sensor).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadTypes(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status);
    });
  }

  confirmAndDeleteSelected(): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => this.deleteSelected(), true);
  }

  deleteSelected(): void {
    if (this.selected.length === 0) { return; }
    const identifiers = this.selected.map(item => ({tenantUuid: item.tenant.uuid, sensor: item.sensor}));

    this.measurementTypesService.deleteMeasurementTypes(identifiers).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadTypes(this.first / this.rows, this.rows);
    }, error => {
      this.failedDeleteList = error.error.typesBeingUsed;
      this.displayFailedDeleteList = true;
    });
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.key === 'f') {
      this.filtersVisible = true;
    }
    if (event.key === 'Escape') {
      this.filtersVisible = false;
    }
  }

}
